<iframe class="iframe" [src]="url" ></iframe> 

